import React from "react";
import { withTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";
import Header from "./../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Boss from "../Home/Boss.png";
import {
  ABOUT_ME_INDUSTRIES,
  ABOUT_ME_PATH,
  ABOUT_ME_SECTIONS,
} from "./sections";
import "./AboutMe.sass";

class AboutMe extends React.Component {
  componentDidMount() {
    document.title = `BluHolding - ${this.props.t("aboutMe")}`;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="AboutMe">
        <Header />
        <section className="section AboutMe__hero" id="profil">
          <div className="AboutMe__hero__text">
            <p className="AboutMe__eyebrow">{t("amProfileTitle")}</p>
            <h1>{t("boss")}</h1>
            <p className="AboutMe__roles">{t("amRoles")}</p>
            <p className="AboutMe__lead">{t("amLead")}</p>
            <nav className="AboutMe__anchors">
              {ABOUT_ME_SECTIONS.map((section) => (
                <HashLink
                  key={section.id}
                  to={`${ABOUT_ME_PATH}#${section.id}`}
                  className="AboutMe__anchor"
                >
                  {t(section.labelKey)}
                </HashLink>
              ))}
            </nav>
          </div>
          <div className="AboutMe__hero__image">
            <img
              draggable={false}
              src={Boss}
              alt="Prezes Krzysztof Błaszkiewicz"
            />
          </div>
        </section>

        <section className="section" id="sukcesy">
          <div className="w100 flex justify-center">
            <h2>{t("amSuccessTitle")}</h2>
          </div>
          <p className="AboutMe__section-lead">{t("amSuccessLead")}</p>
          <div className="grid--3-2-1">
            {this.#points("amSuccess", 3).map((point) => (
              <div className="AboutMe__card" key={point.title}>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section--gray" id="doswiadczenie">
          <div className="w100 flex justify-center">
            <h2>{t("amIndustriesTitle")}</h2>
          </div>
          <p className="AboutMe__section-lead">{t("amIndustriesLead")}</p>
          <div className="AboutMe__anchors">
            {ABOUT_ME_INDUSTRIES.map((industry) => (
              <HashLink
                key={industry.id}
                to={`${ABOUT_ME_PATH}#${industry.id}`}
                className="AboutMe__anchor"
              >
                <span aria-hidden="true">{industry.icon}</span>{" "}
                {t(`${industry.key}Title`)}
              </HashLink>
            ))}
          </div>
          {ABOUT_ME_INDUSTRIES.map((industry) => (
            <article
              className="AboutMe__industry"
              id={industry.id}
              key={industry.id}
            >
              <h3>
                <span aria-hidden="true">{industry.icon}</span>{" "}
                {t(`${industry.key}Title`)}
              </h3>
              <p className="AboutMe__industry__lead">
                {t(`${industry.key}Lead`)}
              </p>
              <ul className="AboutMe__list">
                {this.#points(industry.key, industry.points).map((point) => (
                  <li key={point.title}>
                    <b>{point.title}:</b> {point.text}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>

        <section className="section" id="dzialalnosc-publiczna">
          <div className="w100 flex justify-center">
            <h2>{t("amPublicTitle")}</h2>
          </div>
          <p className="AboutMe__section-lead">{t("amPublicLead")}</p>
          <div className="grid--3-2-1">
            {this.#points("amPublic", 3).map((point) => (
              <div className="AboutMe__card" key={point.title}>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section--gray" id="sport-csr">
          <div className="w100 flex justify-center">
            <h2>{t("amSportTitle")}</h2>
          </div>
          <p className="AboutMe__section-lead">{t("amSportLead")}</p>
          <div className="grid--3-2-1">
            {this.#points("amSport", 3).map((point) => (
              <div className="AboutMe__card" key={point.title}>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </div>
            ))}
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  #points = (key, count) => {
    const { t } = this.props;
    return Array.from({ length: count }, (_, index) => ({
      title: t(`${key}${index + 1}Title`),
      text: t(`${key}${index + 1}Text`),
    }));
  };
}

export default withTranslation()(AboutMe);
